import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { ISalesOrderGroup } from '../../interfaces';

export interface ISalesOrderGroupColumnRendererParams extends ICellRendererParams {
  groups :ISalesOrderGroup[];
}

@Component({
  selector: 'lum-sales-order-group-column',
  templateUrl: './sales-order-group-column.component.html',
  styleUrls: ['./sales-order-group-column.component.scss'],
})
export class SalesOrderGroupColumnComponent implements ICellRendererAngularComp {
  static RenderedRows = new Set<string>();

  #params :ISalesOrderGroupColumnRendererParams;

  #isListening :boolean = false;

  isGridLoading :boolean = true;
  isParentGroupRow :boolean = false;
  isRow :boolean = false;
  group :ISalesOrderGroup | null = null;

  doesRender :boolean = false;

  get isExpanded() {
    return this.#params.node.expanded;
  }

  agInit(params :ISalesOrderGroupColumnRendererParams) :void {
    const uniqueRowId = this.#getUniqueRowId(params);

    this.#params = params;
    this.isParentGroupRow = params.node.group ?? false;
    this.group =
      params.groups.find((g :ISalesOrderGroup) => g.label === params.value) ?? null;

    if (
      !SalesOrderGroupColumnComponent.RenderedRows.has(uniqueRowId) &&
      this.isParentGroupRow
    ) {
      SalesOrderGroupColumnComponent.RenderedRows.add(uniqueRowId);
    }

    this.isRow = !('column' in this.#params);
    // don't render to pinned areas if rendering a whole row
    this.doesRender =
      this.isParentGroupRow &&
      (this.isRow
        ? this.#params.pinned === 'left' // specific to sales order grid
        : true);

    if (this.doesRender) {
      this.#startListening();
    }
  }

  toggleGroup() :void {
    if (this.isParentGroupRow) {
      this.#params.node.setExpanded(!this.isExpanded);
    }
  }

  refresh(params :ISalesOrderGroupColumnRendererParams) :boolean {
    return false;
  }

  #getUniqueRowId(params :ISalesOrderGroupColumnRendererParams) :string {
    return params.node.id?.toString() || '';
  }

  #startListening() {
    if (this.#isListening) {
      return;
    }

    this.#isListening = true;

    this.#params.api.addEventListener('rowDataUpdated', () => {
      this.isGridLoading = false;
    });
  }
}
